import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import useUserRole from '../../hooks/useUserRole';

export default function HomePage() {
  const navigate = useNavigate();

  const { isOwner, isSuperAdmin } = useUserRole();

  useEffect(() => {
    console.log('isOwner', isOwner);
    if (isOwner || isSuperAdmin) {
      navigate('/settings', { replace: true });
    } else {
      navigate('/loan-files', { replace: true });
    }
  }, [isOwner, isSuperAdmin, navigate]);

  return null;
}
